import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './plugins/i18n'
import '@/plugins/inject'
import axios from '@/plugins/http'
import '@/assets/css/variables.scss'
import '@/assets/css/iconfont.css'
import '@/assets/css/global.scss'

Vue.prototype.$axios = axios
Vue.config.productionTip = false

// 启动前先拉全局数据
async function bootstrap() {
  try {
    const data = await axios.get('/Common/getAppGlobalData')
    if (data) {
      store.dispatch('global/initData', data)
    }
  } catch (e) {
    console.error('获取全局数据失败', e)
  }

  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app')
}

bootstrap()